var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car",
    d: "M23.438,9.75H20.631l-.78-1.95a5.224,5.224,0,0,0-4.874-3.3H9.024A5.225,5.225,0,0,0,4.149,7.8l-.78,1.95H.563a.562.562,0,0,0-.545.7L.3,11.574A.562.562,0,0,0,.844,12h.941A2.98,2.98,0,0,0,.75,14.25V16.5a2.976,2.976,0,0,0,.75,1.965V21A1.5,1.5,0,0,0,3,22.5H4.5A1.5,1.5,0,0,0,6,21V19.5H18V21a1.5,1.5,0,0,0,1.5,1.5H21A1.5,1.5,0,0,0,22.5,21V18.466a2.973,2.973,0,0,0,.75-1.965V14.25A2.98,2.98,0,0,0,22.216,12h.941a.562.562,0,0,0,.545-.426l.281-1.125a.563.563,0,0,0-.546-.7Zm-16.5-.836A2.251,2.251,0,0,1,9.024,7.5h5.953a2.251,2.251,0,0,1,2.089,1.414L18,11.25H6l.934-2.336ZM4.5,16.491A1.415,1.415,0,0,1,3,15a1.415,1.415,0,0,1,1.5-1.5,2.886,2.886,0,0,1,2.25,2.243c0,.9-1.35.747-2.25.747Zm15,0c-.9,0-2.25.149-2.25-.747A2.887,2.887,0,0,1,19.5,13.5,1.415,1.415,0,0,1,21,15,1.415,1.415,0,0,1,19.5,16.491Z",
    transform: "translate(0 -4.5)",
    fill: "#c1c1c1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSelect);
export default __webpack_public_path__ + "static/media/car-select.676a59c1a52e725b5740ce7c900db572.svg";
export { ForwardRef as ReactComponent };